import {
  GET_PLAN_PUBLICACION_BY_PRODUCT_ID,
  GET_PLAN_PUBLICACION_BY_PRODUCT_ID_SUCCESS,
  GET_PLAN_PUBLICACION_BY_PRODUCT_ID_ERROR,
  InitialState,
  PlanPublicacionActions,
  PlanPublicacionState,
} from './types'
import { status } from '../typeStatus'

const PlanPublicacionReducer = (
  state: PlanPublicacionState = InitialState,
  action: PlanPublicacionActions
): PlanPublicacionState => {
  switch (action.type) {
    case GET_PLAN_PUBLICACION_BY_PRODUCT_ID: {
      return {
        ...state,
        planByProductId: null,
        status: status.loading,
      }
    }
    case GET_PLAN_PUBLICACION_BY_PRODUCT_ID_SUCCESS: {
      return {
        ...state,
        planByProductId: action.payload,
        status: status.success,
      }
    }
    case GET_PLAN_PUBLICACION_BY_PRODUCT_ID_ERROR: {
      return {
        ...state,
        planByProductId: null,
        status: status.error,
      }
    }

    default:
      return state
  }
}

export default PlanPublicacionReducer
